<template>
  <div class="login-container">
    <div class="reset-password-container">
      <h3 class="title">重置密码</h3>
      <el-steps :active="activeStep" class="custom-steps">
        <el-step title="账号验证" />
        <el-step title="重置密码" />
        <el-step title="完成" />
      </el-steps>

      <!-- 第一步：账号验证 -->
      <div v-if="activeStep === 1">
        <p class="tips">请输入与您的账号关联的电话号码，我们会给您发送验证码来重置密码。</p>
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item label="" prop="userPho">
            <el-input v-model="form.userPho" placeholder="请输入手机号码" ></el-input>
          </el-form-item>
          <el-form-item label="" prop="msgCode">
            <div style="display: flex;">
              <el-input v-model="form.msgCode" placeholder="请输入短信验证码"></el-input>
              <el-button :disabled="!form.userPho || sendingCode" type="primary" @click="sendSmsCode">
                {{ sendingCode ? `${remainingSeconds}秒后重试` : '发送验证码' }}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
        <el-button :disabled="!form.msgCode ||!form.userPho" type="primary" @click="nextStep" class="next-button">下一步</el-button>
      </div>

      <!-- 第二步：重置密码 -->
      <div v-if="activeStep === 2">
        <p class="tips">请设置您的新密码</p>
        <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm">
          <el-form-item label="" prop="newPassword">
            <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码" show-password>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="confirmPassword">
            <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请确认新密码" show-password>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="submitNewPassword" class="next-button">确认修改</el-button>
      </div>

      <!-- 第三步：完成 -->
      <div v-if="activeStep === 3">
        <div class="success-container">
          <i class="el-icon-success success-icon"></i>
          <h4>密码重置成功</h4>
          <p>您的密码已经重置成功，请使用新密码登录</p>
          <el-button type="primary" @click="goToLogin" class="next-button">返回登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/sys/user'
export default {
  data() {
    // 密码验证规则
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (value.length < 6) {
        callback(new Error('密码长度不能小于6位'))
      } else if (!/^(?=.*[a-zA-Z])(?=.*\d)[^]{6,}$/.test(value)) {
        callback(new Error('密码必须包含字母和数字'))
      } else {
        callback()
      }
    }
    // 确认密码验证规则
    const validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      activeStep: 1,
      form: {
        userPho: '',
        msgCode: '',
      },
      passwordForm: {
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        userPho: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur' },
        ],
        msgCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
          // { pattern: /^\d{6}$/, message: '短信验证码应为6位数字', trigger: 'blur' },
        ],
      },
      passwordRules: {
        newPassword: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPass, trigger: 'blur' }
        ]
      },
      sendingCode: false,
      timer: null,
      remainingSeconds: 60,
      sendCode: ''
    }
  },
  methods: {
    sendSmsCode() {
      if (!this.form.userPho) {
        this.$message.warning('请先输入手机号码')
        return
      }
      this.sendingCode = true
      this.remainingSeconds = 60
      this.timer = setInterval(() => {
        if (this.remainingSeconds <= 0) {
          clearInterval(this.timer)
          this.sendingCode = false
          this.remainingSeconds = 60
        } else {
          this.remainingSeconds--
        }
      }, 1000)
      // 后台已不回传验证码明文（防止拿别人手机号取码），验证码只在最后一步由后台校验
      userApi.getMsgCode({ phone: this.form.userPho }).then(res => {
        if (res.code === '0') this.$message.success('发送成功')
      }).catch(() => {
        clearInterval(this.timer)
        this.sendingCode = false
        this.remainingSeconds = 60
      })
      // 这里应该调用后端接口发送验证码，假设接口为 /send-sms-code
      // this.$axios.post('/send-sms-code', { userPho: this.form.userPho })
      // .then(response => {
      //     // 处理成功逻辑
      //   })
      // .catch(error => {
      //     this.$message.error('发送验证码失败')
      //   })
    },
    nextStep() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.activeStep = 2
        }
      })
    },
    switchToEmailVerification() {
      // 切换到邮箱验证逻辑，这里简单提示，实际需实现相关表单切换等操作
      this.$message.info('切换到邮箱验证功能暂未实现')
    },
    submitNewPassword() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          // 添加密码一致性验证
          if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
            this.$message.error('两次输入的密码不一致')
            return
          }
          userApi.loginUpdatePassWord({
            userPho: this.form.userPho,
            msgCode: this.form.msgCode,
            password: this.passwordForm.newPassword
          }).then(res => {
            if (res.code === '0') {
              this.activeStep = 3
            }
          }).catch(() => {
            // 验证码错误/过期等原因已由请求拦截器提示，回到第一步重新获取验证码
            this.activeStep = 1
          })
        }
      })
    },

    goToLogin() {
      this.$router.push('/login')
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>

<style scoped>
.reset-password-container {
  width: 500px;
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  left: calc(50% - 250px);
  padding: 20px;
  border-radius: 5px;
  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); */
}
/* 添加以下样式 */
.custom-steps {
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
}
:v-deep .el-step__head.is-finish,
.el-step__head.is-process {
  margin-left: 20px;
}
:v-deep .el-step__head.is-wait {
  margin-left: 5px;
}
.custom-steps :deep(.el-step) {
  flex: 1;
}

.custom-steps :deep(.el-step__head) {
  margin-right: 0;
}

.custom-steps :deep(.el-step__title) {
  text-align: center;
}
.logo-container {
  text-align: center;
  margin-bottom: 20px;
}
.logo {
  height: 30px;
}
.title {
  font-size: 34px;
  text-align: center;
  margin-bottom: 70px;
}
.tips {
  font-size: 14px;
  text-align: center;
  margin-bottom: 40px;
  color: #666;
  text-align: left;
}
.next-button {
  width: 100%;
  margin-top: 20px;
}
.success-container {
  text-align: center;
  padding: 20px;
}

.success-icon {
  font-size: 48px;
  color: #67c23a;
  margin-bottom: 20px;
}

.success-container h4 {
  font-size: 20px;
  margin-bottom: 10px;
}

.success-container p {
  color: #666;
  margin-bottom: 30px;
}
</style>